/**
 * Booking-related enums that were previously generated in GraphQL types
 * but are now maintained separately to avoid being overwritten during codegen updates.
 */

export enum BookingTypeEnum {
  BOOKINGS = "BOOKINGS",
  WAITLIST = "WAITLIST",
  OPEN = "OPEN",
  LEFT = "LEFT",
  NEW = "NEW"
}

export enum BookingStagesEnum {
  Left = "left"
}

export enum BookingLabelsEnum {
  PackagesRequested = "packages_requested",
  LinkedBooking = "linked_booking",
  AutoConfirmed = "auto_confirmed"
}
